import { secondaryNavSchemasHome } from './secondaryNavSchemasHome.js'

export const SECONDARY_NAV_SCHEMAS = { ...secondaryNavSchemasHome }
